/**
 * Shared layout for global nav routes so the same TrendsHubNav stays mounted
 * when navigating between sections—enabling smooth underline transition for
 * "For you", "Trending", and all other nav links.
 * Centered variant: use ?nav=centered or ?variant=2 (VariantSwitcher writes variant=2).
 */
import React from "react";

import { useSearchParams } from "../hooks/useSearchParams";

import Footer from "./Footer";
import TrendsHubNav from "./TrendsHubNav";

export default function GlobalNavLayout({
  children,
}: {
  children?: React.ReactNode;
}) {
  const [searchParams] = useSearchParams();
  const navCentered =
    searchParams.get("nav") === "centered" ||
    searchParams.get("variant") === "2";
  const borderOff =
    searchParams.get("border") === "off" || searchParams.get("border") === "0";

  return (
    <div
      className="bg-fs-surface-primary flex min-h-screen flex-col"
      style={{ width: "100vw", margin: 0, padding: 0 }}
    >
      <TrendsHubNav tabsCentered={navCentered} borderBelowNav={!borderOff} />
      <main className="flex-1" style={{ width: "100%" }}>
        {children}
      </main>
      <Footer />
    </div>
  );
}
